import { render, staticRenderFns } from "./MessageEntry.vue?vue&type=template&id=3666ff42&"
import script from "./MessageEntry.vue?vue&type=script&lang=js&"
export * from "./MessageEntry.vue?vue&type=script&lang=js&"
import style0 from "./MessageEntry.vue?vue&type=style&index=0&lang=module.scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports